import Immutable from "immutable"
import { createSelector, createStructuredSelector } from "reselect"
import { selectTeams, findTeamByResourceUri } from "shared/userdata/userdata-selectors"
import constants from "sheets/constants"
import { selectStancesWithCustomLabels } from "shared/stance/selectors"
import { stanceWithCustomLabelByValue } from "shared/stance/helperFunctions"

const selectCellValueFromProps = (_, props) => props.cellValue
// IconTypeCell specific
const selectDjangioType = (_, props) => props.djangioType
const selectValue = (_, props) => props.value
const selectLabelField = (_, props) => props.labelField
const selectIconOverride = (_, props) => props.iconOverride

export const selectValueForPercentageCell = createSelector(
    (_, props) => props.children,
    (value) => value && value * 100,
)

export const percentageCellConnection = createStructuredSelector({
    value: selectValueForPercentageCell,
})

// return the name of the teams, data provided the the userdata.teams slice of the store
export const selectTeamNamesFromUserdataSlice = createSelector(
    selectTeams,
    selectCellValueFromProps,
    (teamMap, cellValue) => {
        // process multiple items
        if (cellValue && cellValue.constructor === Immutable.List) {
            return cellValue
                .map((resourceUri) => findTeamByResourceUri(teamMap, resourceUri).get("name") || "")
                .join(", ")
        }

        // process single item
        return findTeamByResourceUri(teamMap, cellValue).get("name") || ""
    },
)

export const selectIconTypeLabel = createSelector(
    selectDjangioType,
    selectValue,
    selectLabelField,
    selectStancesWithCustomLabels,
    (djangioType, value, labelField, stancesWithCustomLabels) => {
        let valueObj
        if (djangioType === DjangIO.app.userdata.types.LegislativeStanceType) {
            valueObj = stanceWithCustomLabelByValue(stancesWithCustomLabels, value)
        } else {
            valueObj = djangioType && djangioType.by_value(value)
        }
        let label = labelField ? valueObj && valueObj[labelField] : valueObj && valueObj.label

        // If we are display Legislative Priorities, strip out the " Priority" portion of the string.
        if (
            label &&
            djangioType === DjangIO.app.userdata.types.LegislativePriorityType &&
            value !== DjangIO.app.userdata.types.LegislativePriorityType.no_priority.value
        ) {
            label = label.split(constants.PRIORITY_STRING)[0]
        }
        return label
    },
)

export const selectIconTypeIcon = createSelector(
    selectDjangioType,
    selectValue,
    selectIconOverride,
    (djangioType, value, override) => {
        if (override) {
            return override
        }
        const djangioObj = djangioType && djangioType.by_value(value)
        if (djangioObj === DjangIO.app.models.QuorumDataType.note) {
            return "file-edit"
        }
        return djangioObj && djangioObj.fa5_icon
    },
)

export const selectIconTypeIconFamily = createSelector(selectDjangioType, selectValue, (djangioType, value) => {
    const djangioObj = djangioType && djangioType.by_value(value)
    if (djangioObj === DjangIO.app.models.QuorumDataType.vote) {
        return "far"
    }
    return (djangioObj && djangioObj.fa5_icon_family) || "fal"
})

export const objectCacheCellConnection = createStructuredSelector({
    cellValueFromCache: selectTeamNamesFromUserdataSlice,
})

export const iconTypeCellConnection = createStructuredSelector({
    label: selectIconTypeLabel,
    icon: selectIconTypeIcon,
    iconFamily: selectIconTypeIconFamily,
})
